import React from 'react';
import PropTypes from 'prop-types';
import Label from 'ui/text/Label';
import QRCodeGenerator from 'components/QRCodeGenerator';

// The buyer presents this QR at the store for collection — rendered client-side
// from the instance uuid (the server qr_code_url may still be attaching).
const Image = ({ reference }) => {
  return (
    <div className={"fullwidth-card-image-container"}>
      <QRCodeGenerator url={reference} />
      <Label>{reference}</Label>
    </div>
  );
};

Image.propTypes = {
  reference: PropTypes.string,
};

export default Image;
